import http from '../utils/http';

export const getNotifications = () => http.get('/messaging/notifications');

export const sendNotification = (data) =>
  http.post('/messaging', {
    ...data,
  });
